import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { ROUTE_MENU, REACT_APP_CLOUD_FRONT, BANNER_ITEM_REDIRECT, BANNER_CATEGORY_REDIRECT } from "../../constants";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import stylesClasses from "./HeroBannerNew.module.scss";
import { useAppSelector } from "../../redux/store/store";
import { useStoreLocation } from "../../context/StoreLocation";
const HomePageBanner = () => {
  const history = useHistory();
  const isItMobile = useCheckMobileScreen();
  const isCheckTrackBar = useAppSelector((state) => state.checkout?.trackOrder);

    const isOrderTypeSelected = useAppSelector(
      (state) => state.cart.isOrderTypeSelected
    );
  const { locationInfo } = useStoreLocation();

  const [isDeviceIos, setIsDeviceIos] = React.useState(false);

  useEffect(() => {
    var userAgent = navigator.userAgent || navigator.vendor;
    if (/iPad|iPhone|iPod|Mac/.test(userAgent) && !window.MSStream) {
      setIsDeviceIos(true);
    } else {
      setIsDeviceIos(false);
    }
  }, []);

  return (
    <>
    <div
      className={`${stylesClasses.HomePageBannerWrapper} ${
        isCheckTrackBar && stylesClasses.trackBarExist
      }`}
    >
      <div
        className={stylesClasses.backgroundImage}
      >
        <div
          className={` ${stylesClasses.imageWrapper} ${
            isItMobile ? "cz-mt-6" : "cz-mt-30"
          } `}
        >
          {!isItMobile ? (
            <img
              src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/heroBannerDesktop.png?v=${process.env.REACT_APP_HOMEPAGE_BANNER_VERSION || Date.now()}`}
              alt="Desktop Banner"
            />
          ) : (
            <img
              src={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/heroBannerMobile.png?v=${process.env.REACT_APP_HOMEPAGE_BANNER_VERSION || Date.now()}`}
              alt="Mobile Banner"
            />
          )}
        </div>
        <div className={`d-flex gap-3 ${stylesClasses.hero_banner_btn}`}>
        <button
            className={`btn btn-large font-trade-gothic-next ${stylesClasses.order_btn}`}
            onClick={() => {
              if(isOrderTypeSelected && locationInfo.selectedStore){
                history.push(BANNER_ITEM_REDIRECT);
              }else{
                history.push(BANNER_CATEGORY_REDIRECT);
              }
            }} >
              Order Now
        </button>
        </div>
        {/* <div 
        className={`${stylesClasses.banner_text}`}>
          <p 
          className={`${stylesClasses.banner_heading}`}>
          The viral chocolate<br/>
          strawberry cup is here.
          </p>
          <p
            className={`${stylesClasses.banner_description}`}
            >Because nobody does the duo better than us.</p>
        </div>
        <div>
          <button
            className={`btn btn-large ${stylesClasses.order_btn}`}
            onClick={() => {
              history.push(ROUTE_MENU);
            }}
          >
            Order Now
          </button>
        </div> */}
      </div>
    </div>
    </>
  );
};

export default HomePageBanner;